import React, { PropsWithChildren, useEffect, useState } from 'react';
import {
  Popup
} from '@tencentcloud/chat-uikit-react';
import '@tencentcloud/chat-uikit-react/dist/cjs/index.css';
import giftIcon from './image/giftbox.png';
import gifConfirmGift from './image/confirm_gift.png';

import './style.scss'
import constant, { STORAGE_NAME } from '../../constants';
import Toast from '../Toast';
import TIM from 'tim-js-sdk';
import a18n from 'a18n';
import languages from '../../languages';

interface LiveGiftProps {
  callback?: (data: any) => void,
  setIsChatShow?: any,
  setIsGiftShow?: any,
  isGiftShow?: boolean,
  setIsShowAction?: any,
  isShowAction?: boolean,
  groupID?: any,
  tim?: any,
}

export function LiveGift<T extends LiveGiftProps>({
  callback,
  setIsChatShow,
  setIsGiftShow,
  isGiftShow,
  setIsShowAction,
  isShowAction,
  groupID,
  tim,
}: PropsWithChildren<T>): React.ReactElement {
  const [className, setClassName] = useState<string>('');
  const [money, setMoney] = useState<number>(0);
  const [payTotal, setpPyTotal] = useState<number>(100);
  const [giftList, setGiftList] = useState([]);
  const [confirmSendGiftShow, setConfirmSendGiftShow] = useState<boolean>(false);
  const [sendGiftData, setSendGiftData] = useState({});
  const languageCurrent: string = a18n.getLocale();

  const handleShow = () => {
    setIsGiftShow && setIsGiftShow(!isGiftShow);
    setIsChatShow && setIsChatShow(false);
    setIsShowAction && setIsShowAction(false);
  }

  const handleVisible = (data: any) => {
    setClassName(`${!data.top && 'emoji-plugin-top'} ${!data.left && 'emoji-plugin-right'}`);
  }

  const handleShowConfirmPopup = (item: any) => {
    setConfirmSendGiftShow(prevState => !prevState);
    item && setSendGiftData(item);
  }

  const sendGift = (data: any) => {
    if (!sendGiftData) {
      return;
    }

    data = sendGiftData;
    const val = money - data.gift_price;
    if (val < 0) {
      handleShow();
      handleShowConfirmPopup({});

      Toast.error(languages[languageCurrent]?.notEnoughMoney, 2000);
      return console.warn('not enough money');
    }
    const total = payTotal + data.gift_price;
    setpPyTotal(total);
    callApiSendGift(data);
    setMoney(val);
    handleShow();
    handleShowConfirmPopup({});
    const level = parseInt(`${total / 100}`, 10);
    callback && callback(level);
  }


  const callApiSendGift = (data: any) => {
    var currentPost = JSON.parse(localStorage.getItem(STORAGE_NAME.CURRENT_POST + searchParams.get("roomId")) ?? '{}');
    var postId = searchParams.get('roomId') ?? '';
    var userId = searchParams.get('userId') ?? '';
    var formdata = new FormData();
    var apiHeaders = new Headers();

    apiHeaders.append('Access-Control-Allow-Origin', '*');
    apiHeaders.append('Access-Control-Allow-Credentials', 'true');
    formdata.append("user_id", userId);
    formdata.append("post_id", postId);
    formdata.append("amount", data.gift_price);
    formdata.append("recipient_id", currentPost?.post_data?.post_author);
    formdata.append("log", 'Donation');
    formdata.append("reference", 'donation');
    formdata.append("ctype", 'mycred_default');
    formdata.append("action", 'transfers_points');

    fetch(constant.apiUrl + "/wp-json/stream/send-gift", {
      method: 'POST',
      body: formdata,
    })
      .then(response => response.text())
      .then(result => {
        let apiResult = JSON.parse(result);

        if (!apiResult.data) {
          Toast.error(apiResult.message ?? 'Donate failed', 2000);
          return;
        }

        try {
          let message = tim.createCustomMessage({
            to: groupID,
            conversationType: TIM.TYPES.CONV_GROUP,
            payload: {
              data: '',
              description: '',
              extension: languages[languageCurrent]?.donationNotify?.replace('{0}', data?.gift_price)
            }
          });
          
          tim.sendMessage(message);
        } catch (imError) {
          console.error('Donate failed:', imError);
        }
        Toast.success(languages[languageCurrent]?.donateSuccess?.replace('{0}', data?.gift_price), 2000);
      })
      .catch(error => {
        console.log('error', error);
        Toast.error(languages[languageCurrent]?.donateFailed, 2000);
      });
  }

  const searchParams = new URLSearchParams(document.location.search);
  useEffect(() => {
    fetch(constant.apiUrl + "/wp-json/gift/get-list?user_id=" + searchParams.get('userId'))
      .then(res => res.json())
      .then(
        (result) => {
          setGiftList(result.gift_list);
          setMoney(result.money)
        },
        (error) => {
          console.log(error.message);
        }
      )

  }, []);

  return (
    <div className='tui-gift'>
      { searchParams.get('role') != constant.roleLiver && 
      <div className='tui-gift-wallet show-gift-button' onClick={handleShow}>
        <img className="icon-gift" src={giftIcon} alt="" />
        <span>{languages[languageCurrent]?.buttonGift}</span>
      </div>
      }
      <Popup
        className={`tui-gift-popup ${className}`}
        show={isGiftShow}
        handleVisible={handleVisible}
      >
        {/* <header className='tui-gift-popup-header'> */}
        {/* <h1>Rewards</h1> */}
        {/* <i className='icon-close' onClick={handleShow}></i> */}
        {/* </header> */}
        <ol className='tui-gift-list'>
          {
            giftList.map((item) => (
              <dl className='tui-gift-item' key={item['gift_name']} onClick={() => { handleShowConfirmPopup(item) }}>
                <dd style={{
                  background: "#FFD9C2",
                  borderRadius: "10px",
                  border: "2px solid #FA9550",
                  color: "#FFD9C2"
                }}>
                  <img className='gift-item-icon' src={`/wp-content/uploads${item['gift_img']}`} alt="" />
                  <div className='tui-gift-wallet'>
                    <span style={{ color: "#E37318" }}>{item['gift_price']}</span>
                  </div>
                </dd>
                <dt className='tui-gift-name' style={{ color: "white" }}>{item['gift_name']}</dt>
              </dl>
            ))
          }
        </ol>
      </Popup>
        <Popup
          className='popup-confirm-send-gift'
          show={confirmSendGiftShow}
        >
          <div className='popup-confirm-send-gift-area'>
            <div className='popup-confirm-send-gift-box'>
              <div className='area-header'>
                <img className='icon-confirm' src={gifConfirmGift} alt="" />
                <div>
                  <h1>{languages[languageCurrent]?.giftPopupConfirmTitle}</h1>
                  <p>{languages[languageCurrent]?.giftPopupConfirmDescription}</p>
                </div>
              </div>
              <div className='area-content'>
                <button className='button-confirm-send-gift' onClick={sendGift} >{languages[languageCurrent]?.buttonConfirm}</button>
                <button className={`${languageCurrent == 'ja' && 'button-cancel-send-gift-ja'}`} onClick={handleShowConfirmPopup}><span>{languages[languageCurrent]?.buttonCancel}</span></button>
              </div>
            </div>
          </div>
        </Popup>
    </div>
  )
}  